// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f24a66c1550f2a01bef8","303":"aecb188fd3e8ede1b415","495":"1b99b0878efb53aff9df"}[chunkId] + ".js";
};